/*
 * @Author: scos_fx
 * @Date: 2019-12-19 14:48:25
 * @LastEditors: scos_fx
 */

// 无线国家码定义
 export default {
    AL: {val:'AL',countryName:'ALBANIA'},
    DZ: {val:'DZ',countryName:'ALGERIA'},
    AR: {val:'AR',countryName:'ARGENTINA'},
    AM: {val:'AM',countryName:'ARMENIA'},
    AU: {val:'AU',countryName:'AUSTRALIA'},
    AT: {val:'AT',countryName:'AUSTRIA'},
    AZ: {val:'AZ',countryName:'AZERBAIJAN'},
    BH: {val:'BH',countryName:'BAHRAIN'},
    BY: {val:'BY',countryName:'ELARUS'},
    BE: {val:'BE',countryName:'BELGIUM'},
    BZ: {val:'BZ',countryName:'BELIZE'},
    BO: {val:'BO',countryName:'BOLIVIA'},
    BR: {val:'BR',countryName:'BRAZIL'},
    BN: {val:'BN',countryName:'BRUNEI'},
    BG: {val:'BG',countryName: 'BULGARIA'},
    CA: {val:'CA',countryName: 'CANADA'},
    CL: {val:'CL',countryName: 'CHILE'},
    CN: {val:'CN',countryName: 'CHINA'},
    CO: {val:'CO',countryName: 'COLOMBIA'},
    CR: {val:'CR',countryName: 'COSTA RICA'},
    HR: {val:'HR',countryName: 'CROATIA'},
    CY: {val:'CY',countryName: 'CYPRUS'},
    CZ: {val:'CZ',countryName: 'CZECH REPUBLIC'},
    DK: {val:'DK',countryName: 'DENMARK'},
    DO: {val:'DO',countryName: 'DOMINICAN REPUBLIC'},
    EC: {val:'EC',countryName: 'ECUADOR'},
    EG: {val:'EG',countryName: 'EGYPT'},
    SV: {val:'SV',countryName: 'EL SALVADOR'},
    EE: {val:'EE',countryName: 'ESTONIA'},
    FI: {val:'FI',countryName: 'FINLAND'},
    FR: {val:'FR',countryName: 'FRANCE'},
    GE: {val:'GE',countryName: 'GEORGIA'},
    DE: {val:'DE',countryName: 'GERMANY'},
    GR: {val:'GR',countryName: 'GREECE'},
    GT: {val:'GT',countryName: 'GUATEMALA'},
    HN: {val:'HN',countryName: 'HONDURAS'},
    HK: {val:'HK',countryName: 'HONG KONG'},
    HU: {val:'HU',countryName: 'HUNGARY'},
    IS: {val:'IS',countryName: 'ICELAND'},
    IN: {val:'IN',countryName: 'INDIA'},
    ID: {val:'ID',countryName: 'INDONESIA'},
    IR: {val:'IR',countryName: 'IRAN'},
    IE: {val:'IE',countryName: 'IRELAND'},
    IL: {val:'IL',countryName: 'ISRAEL'},
    IT: {val:'IT',countryName: 'ITALY'},
    JP: {val:'JP',countryName: 'JAPAN'},
    JO: {val:'JO',countryName: 'JORDAN'},
    KZ: {val:'KZ',countryName: 'KAZAKHSTAN'},
    KR: {val:'KR',countryName: 'NORTH KOREA'},
    KP: {val:'KP',countryName: 'KOREA REPUBLIC'},
    KW: {val:'KW',countryName: 'KUWAIT'},
    LV: {val:'LV',countryName: 'LATVIA'},
    LB: {val:'LB',countryName: 'LEBANON'},
    LI: {val:'LI',countryName: 'LIECHTENSTEIN'},
    LT: {val:'LT',countryName: 'LITHUANIA'},
    LU: {val:'LU',countryName: 'LUXEMBOURG'},
    MO: {val:'MO',countryName: 'CHINA MACAU'},
    MK: {val:'MK',countryName: 'MACEDONIA'},
    MY: {val:'MY',countryName: 'MALAYSIA'},
    MX: {val:'MX',countryName: 'MEXICO'},
    MC: {val:'MC',countryName: 'MONACO'},
    MA: {val:'MA',countryName: 'MOROCCO'},
    NL: {val:'NL',countryName: 'NENDS'},
    NZ: {val:'NZ',countryName: 'NEAND'},
    NO: {val:'NO',countryName: 'NORWAY'},
    OM: {val:'OM',countryName: 'OMAN'},
    PK: {val:'PK',countryName: 'PAKISTAN'},
    PA: {val:'PA',countryName: 'PANAMA'},
    PE: {val:'PE',countryName: 'PERU'},
    PH: {val:'PH',countryName: 'PHILIPPINES'},
    PL: {val:'PL',countryName: 'POLAND'},
    PT: {val:'PT',countryName: 'PORTUGAL'},
    PR: {val:'PR',countryName: 'PUERTO RICO'},
    QA: {val:'QA',countryName: 'QATAR'},
    RO: {val:'RO',countryName: 'ROMANIA'},
    RU: {val:'RU',countryName: 'RUSSIAN'},
    SA: {val:'SA',countryName: 'SAUDI ARABIA'},
    SG: {val:'SG',countryName: 'SINGAPORE'},
    SK: {val:'SK',countryName: 'SLOVAKIA'},
    SI: {val:'SI',countryName: 'SLOVENIA'},
    ZA: {val:'ZA',countryName: 'SOUTH AFRICA'},
    ES: {val:'ES',countryName: 'SPAIN'},
    SE: {val:'SE',countryName: 'SWEDEN'},
    CH: {val:'CH',countryName: 'SWITZERLAND'},
    SY: {val:'SY',countryName: 'SYRIAN ARAB REPUBLIC'},
    TW: {val:'TW',countryName: 'TAIWAN'},
    TH: {val:'TH',countryName: 'THAILAND'},
    TT: {val:'TT',countryName: 'TRINIDAD AND TOBAGO'},
    TN: {val:'TN',countryName: 'TUNISIA'},
    TR: {val:'TR',countryName: 'TURKEY'},
    UA: {val:'UA',countryName: 'UKRAINE'},
    AE: {val:'AE',countryName: 'UNITED ARAB EMIRATES'},
    GB: {val:'GB',countryName: 'UNITED KINGDOM'},
    US: {val:'US',countryName: 'UNITED STATES'},
    UY: {val:'UY',countryName: 'URUGUAY'},
    UZ: {val:'UZ',countryName: 'UZBEKISTAN'},
    VE: {val:'VE',countryName: 'VENEZUELA'},
    VN: {val:'VN',countryName: 'VIET NAM'},
    YE: {val:'YE',countryName: 'YEMEN'},
    ZW: {val:'ZW',countryName: 'ZIMBABWE'}
 }

